'use client'

import { useEffect, useState } from 'react'
import { ShoppingBag } from 'lucide-react'
import { resolveShopImageUrl } from '@/features/shop/lib/shop-image'

/** A deal card's photo: walks the product's images until one loads. */
export function DealImage({ images, title }: { images: string[]; title: string }) {
  const candidates = images
    .map((image) => resolveShopImageUrl(image, 480))
    .filter((image): image is string => Boolean(image))
  const signature = candidates.join('|')
  const [index, setIndex] = useState(0)
  useEffect(() => setIndex(0), [signature])
  return (
    <div className="flex aspect-square items-center justify-center overflow-hidden rounded-md bg-card">
      {candidates[index] ? (
        // Served by the Shop's own image proxy, a host the optimizer allowlist
        // can't cover — plain <img>, with the Shop doing the resizing.
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={candidates[index]}
          alt={title}
          loading="lazy"
          onError={() => setIndex((value) => value + 1)}
          className="h-full w-full object-contain p-4"
        />
      ) : (
        <ShoppingBag className="h-8 w-8 text-muted-foreground" />
      )}
    </div>
  )
}
